import { useSearchParams } from 'next/navigation';
import { TSearchParams } from '@/_types/route-params';
import { getSearchParamsFromUrlString } from '@/_hooks/_utils/get-search-params-from-url-string';

export const useClientSearchParams = (): TSearchParams => {
  const searchParams = useSearchParams();

  return getSearchParamsFromUrlString(searchParams);
};
